// extracted by mini-css-extract-plugin
export default {"categoryContainer":"PluginsCategories_categoryContainer__QoiN-","activeCategory":"PluginsCategories_activeCategory__U6sTJ","categoryText":"PluginsCategories_categoryText__T5iel"};